import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NestApiProvider } from '../../nest-api';
import { RequestAPI } from '../dto/request.dto';

@Injectable()
export class GreatdayApi {
    private service = 'greatday';
    private model = 'generic';

    constructor(private nestApi: NestApiProvider) {}

    get(request: RequestAPI): Observable<any> {
        const method = 'GET';
        const url = this.nestApi.urlBuilder(
            method,
            request.model ? request.model : this.model,
            request.func,
            request.params,
            request.queryParams,
            this.service
        );
        return this.nestApi.request(method, url, request.params, request.queryParams, request.body);
    }

    getBlob(request: RequestAPI): Observable<any> {
        const method = 'GET';
        const url = this.nestApi.urlBuilder(
            method,
            request.model ? request.model : this.model,
            request.func,
            request.params,
            request.queryParams,
            this.service
        );
        return this.nestApi.requestBlob(method, url, request.params, request.queryParams, request.body);
    }

    post(request: RequestAPI): Observable<any> {
        const method = 'POST';
        const url = this.nestApi.urlBuilder(
            method,
            request.model ? request.model : this.model,
            request.func,
            request.params,
            request.queryParams,
            this.service
        );
        return this.nestApi.request(method, url, request.params, request.queryParams, request.body);
    }

    postUpload(request: RequestAPI): Observable<any> {
        const method = 'POST';
        const url = this.nestApi.urlBuilder(
            method,
            request.model ? request.model : this.model,
            request.func,
            request.params,
            request.queryParams,
            this.service
        );
        return this.nestApi.requestMethod(method, url, request.params, request.queryParams, request.body);
    }

    put(request: RequestAPI): Observable<any> {
        const method = 'PUT';
        const url = this.nestApi.urlBuilder(
            method,
            request.model ? request.model : this.model,
            request.func,
            request.params,
            request.queryParams,
            this.service
        );
        return this.nestApi.request(method, url, request.params, request.queryParams, request.body);
    }

    delete(request: RequestAPI): Observable<any> {
        const method = 'DELETE';
        const url = this.nestApi.urlBuilder(
            method,
            request.model ? request.model : this.model,
            request.func,
            request.params,
            request.queryParams,
            this.service
        );
        return this.nestApi.request(method, url, request.params, request.queryParams, request.body);
    }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/greatday.api.ts